// Utility to compress images using browser-image-compression
import imageCompression from 'browser-image-compression';

/**
 * Compress an image file using browser-image-compression
 * @param {File|Blob} file - The image file to compress
 * @param {Object} [options] - Compression options
 * @returns {Promise<File>} - Compressed image file
 */
export async function compressImage(file, options = {}) {
  const defaultOptions = {
    maxSizeMB: 0.5,
    maxWidthOrHeight: 1200,
    useWebWorker: true,
    ...options
  };
  return await imageCompression(file, defaultOptions);
}
